import { render } from "./job_details.vue?vue&type=template&id=77a01796"
import script from "./job_details.vue?vue&type=script&lang=js"
export * from "./job_details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__